import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import {
  ApiResponse,
  callAPI,
  customValidation,
  Method,
  validations,
} from "../../commonFunctions/CommonFunctions";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../Config/clientConfig.json"
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import http from "../../commonFunctions/httpClient";

export const BusinessDetails: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, reset } = useForm();

  const [loading, setLoading] = useState(false);

  const params = useParams();
  const id = params?.id;

  const { showMessage } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await callAPI(
          "Vyapar/BusinessDetails/By-user",
          Method.GET
        );

        console.log("fetchData response===>", response);

        if (response?.data) {
          const data = response.data;

          reset({
            businessName: data.businessName,
            phoneNumber: data.phoneNumber,
            gstIn: data.gstin,
            email: data.email,
            druglicense: data.drugLicenceNumber,
            fssaiNo: data.fssaino,
            businessAddress: data.businessAddress,
            state: data.state,
            pinCode: data.pincode,
            category: data.businessCategory,
            type: data.businessType
          });
        }
      } catch (error) {
        console.error("Failed to fetch business data:", error);
      }
    };

    fetchData();
  }, []);

  const handleData = async (data: any) => {
    console.log("onsubmit===>", data);

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("BusinessName", data.businessName);
      formData.append("BusinessType", data.type);
      formData.append("BusinessAddress", data.businessAddress);
      formData.append("PhoneNumber", data.phoneNumber);
      formData.append("BusinessCategory", data.category || "Textile");

      formData.append("GSTIN", data.gstIn);
      formData.append("State", data.state || "Kerala");
      formData.append("Email", data.email);
      formData.append("Pincode", data.pinCode || "670001");

      formData.append("DrugLicenceNumber", data.druglicense);
      formData.append("FSSAINO", data.fssaiNo);

      if (data.addLogo && data.addLogo[0]) {
        formData.append("LogoPath", data.addLogo[0]);
      }

      if (data.signature && data.signature[0]) {
        formData.append("SignaturePath", data.signature[0]);
      }

      const response = await http.putFormData<ApiResponse>(
        "Vyapar/BusinessDetails",
        formData
      );

      console.log("handleData response===>", response);

      if (response) {
        showMessage(
          response?.message,
          response.success ? "success" : "error"
        );
      }
    } catch (error) {
      console.error("Failed to save business:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    navigate("/");
  };

  return (
    <Grid p={3}>
      <Paper
        elevation={0}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 0,
          paddingBottom: 25,
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <WSImageUpload
              control={control}
              id="addLogo"
              name="addLogo"
              label=""
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {" "}
                  Business Details
                </Typography>
              </Grid>
              <Grid item>
                <WSTextField
                  label={"Business Name *"}
                  {...register("businessName")}
                  id="businessName"
                  name="businessName"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item>
                <WSPhone
                  label={"Phone Number"}
                  id={"phoneNumber"}
                  name={"phoneNumber"}
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"GSTIN"}
                  {...register("gstIn")}
                  id="gstIn"
                  name="gstIn"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  className="form-control"
                  id="email"
                  type={TextType.Text}
                  rules={customValidation(false, validations.email)}
                  {...register("email")}
                  label="Email Id"
                  control={control}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"Enter Drug License Number"}
                  {...register("druglicense")}
                  id="druglicense"
                  name="druglicense"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {" "}
                  More Details
                </Typography>
              </Grid>
              <Grid item>
                <WSSelectField
                  rules={{ required: true }}
                  control={control}
                  id="type"
                  {...register("type")}
                  name="type"
                  label="Business Type"
                  options={config.businessType.staticOptionData}
                />
              </Grid>
              <Grid item>
                <WSSelectField
                  rules={{ required: true }}
                  control={control}
                  id="category"
                  {...register("category")}
                  name="category"
                  label="Business Category"
                  options={config.businessCategoryOptions.staticOptionData}
                />
              </Grid>
              <Grid item>
                <WSSelectField
                  rules={{ required: false }}
                  {...register("state")}
                  id="state"
                  control={control}
                  defaultValue={config.stateConfig.staticOptionData[11].value}
                  label="State"
                  name="state"
                  options={config.stateConfig.staticOptionData}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"Pin Code"}
                  {...register("pinCode")}
                  id="pinCode"
                  name="pinCode"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"FSSAI NO"}
                  {...register("fssaiNo")}
                  id="fssaiNo"
                  name="fssaiNo"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} mt={5}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <WSTextAreaField
                  label={"Business Address"}
                  id={"businessAddress"}
                  name={"businessAddress"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />
              </Grid>
              <Grid item>
                <WSFileUpload
                  name="signature"
                  label="Add signature"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png"
                  maxFileSizeMB={2}
                  //  defaultValue={defaultImg}
                  id={"signature"}
                  image={true}
                  align="Start"
                  isToolTipImg={false}
                  multiple={true}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
              />
            </Grid>

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save Changes"
                size="medium"
                variant="contained"
                color="primary"
                loading={loading}
                onClick={handleSubmit(handleData)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>

    </Grid>
  );
});
